import { z } from 'zod';

export const referenceTextFieldMaxLength = 420;
export const referenceQuoteFieldMaxLength = 350;
export const referenceQuoteByFieldMaxLength = 40;
export const referenceNotesFieldMaxLength = 2000;

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const NewCustomerReferenceForm = z.object({
    reference_title: z.string().max(referenceQuoteByFieldMaxLength),
    quote: z.string().min(0).max(referenceQuoteFieldMaxLength),
    quote_by: z.string().min(0).max(referenceQuoteByFieldMaxLength),
    quote_by_title: z.string().min(0).max(referenceQuoteByFieldMaxLength),
    solution: z.string().min(1).max(referenceTextFieldMaxLength),
    challenge: z.string().min(1).max(referenceTextFieldMaxLength),
    permission_to_use: z.boolean(),
    notes: z.string().optional(),
    image_url: z.string().optional(),
    image_file: z
        .instanceof(File, { message: 'Reference background image is required' })
        .refine(file => !file || file.size <= MAX_FILE_SIZE, {
            message: 'File size must be less than 5MB.',
        })
        .refine(file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type), {
            message: 'Only .jpg, .jpeg, and .png formats are supported.',
        }),
    image_name: z.string().optional(),
    logo_url: z.string().optional(),
    logo_presigned_url: z.string().optional(),
    logo_file: z
        .instanceof(File)
        .optional()
        .refine(file => !file || file.size <= MAX_FILE_SIZE, {
            message: 'File size must be less than 5MB.',
        })
        .refine(file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type), {
            message: 'Only .jpg, .jpeg, and .png formats are supported.',
        }),
});

export const EditCustomerReferenceForm = z.object({
    reference_uuid: z.string(),
    reference_title: z.string().max(referenceQuoteByFieldMaxLength),
    challenge: z.string().min(1).max(referenceTextFieldMaxLength),
    solution: z.string().min(1).max(referenceTextFieldMaxLength),
    quote: z.string().min(0).max(referenceQuoteFieldMaxLength),
    quote_by: z.string().min(0).max(referenceQuoteByFieldMaxLength),
    quote_by_title: z.string().min(0).max(referenceQuoteByFieldMaxLength),
    permission_to_use: z.boolean(),
    notes: z.string().optional(),
    image_url: z.string().optional(),
    presigned_url: z.string().optional(),
    image_file: z
        .instanceof(File)
        .optional()
        .refine(file => !file || file.size <= MAX_FILE_SIZE, {
            message: 'File size must be less than 5MB.',
        })
        .refine(file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type), {
            message: 'Only .jpg, .jpeg, and .png formats are supported.',
        }),
    image_name: z.string().optional(),
    logo_url: z.string().optional(),
    logo_presigned_url: z.string().optional(),
    logo_file: z
        .instanceof(File)
        .optional()
        .refine(file => !file || file.size <= MAX_FILE_SIZE, {
            message: 'File size must be less than 5MB.',
        })
        .refine(file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type), {
            message: 'Only .jpg, .jpeg, and .png formats are supported.',
        }),
});

export type NewCustomerReferenceFormType = z.infer<typeof NewCustomerReferenceForm>;
export type EditCustomerReferenceFormType = z.infer<typeof EditCustomerReferenceForm>;
